import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/notfound.css';
import GoBackButton from './GoBackButton';

export default function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <div style={{ marginBottom: '30px' }}>
          <GoBackButton />
        </div>
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-message">Oops! Page not found</h2>
        <p className="notfound-description">
          The page you're looking for doesn't exist or has been moved.
        </p>
        {/* <Link to="/" className="notfound-home-button">
          Go Back Home
        </Link> */}
      </div>
    </div>
  );
}
